module.exports = __webpack_public_path__ + "static/media/darc.899e1c39.png";